import { useIdParam } from '@/react/hooks/useIdParam';

import { PageHeader } from '@@/PageHeader';

import { useEnvironment } from '../queries';
import { getPlatformTypeName, isEdgeEnvironment } from '../utils';
import { Environment } from '../types';
import { k8sInstallTitles } from '../wizard/EnvironmentsCreationView/WizardK8sInstall/types';

import { EdgeInformationPanel } from './EdgeInformationPanel/EdgeInformationPanel';
import { EdgeAgentDeploymentWidget } from './EdgeAgentDeploymentWidget/EdgeAgentDeploymentWidget';
import { KubeConfigInfo } from './KubeConfigInfo/KubeConfigInfo';
import { EnvironmentDetailsForm } from './EnvironmentDetailsForm';
import { Microk8sClusterDetails } from './Microk8sClusterDetails';
import { KaaSClusterDetailsWidget } from './KaaSClusterDetailsWidget/KaaSClusterDetailsWidget';

export function ItemView() {
  const id = useIdParam();
  const environmentQuery = useEnvironment(id);

  if (!environmentQuery.data) {
    return null;
  }

  const environment = environmentQuery.data;

  const isEdge = isEdgeEnvironment(environment.Type);
  const platformName = getPlatformTypeName(environment.Type);

  return (
    <>
      <PageHeader
        title="Environment details"
        breadcrumbs={[
          { label: 'Environments', link: 'portainer.endpoints' },
          environment.Name,
        ]}
        reload
      />

      <div className="mx-4 space-y-4 [&>*]:block">
        {isEdge &&
          (environment.EdgeID ? (
            <EdgeInformationPanel
              environmentId={id}
              edgeKey={environment.EdgeKey}
              edgeId={environment.EdgeID}
              platformName={platformName}
            />
          ) : (
            <EdgeAgentDeploymentWidget
              edgeKey={environment.EdgeKey}
              edgeId={environment.EdgeID}
              asyncMode={environment.Edge?.AsyncMode}
            />
          ))}

        <KubeConfigInfo
          environmentId={id}
          environmentType={environment.Type}
          edgeId={environment.EdgeID}
          status={environment.Status}
        />

        {environment.CloudProvider &&
          (isMicroK8s(environment) ? (
            <Microk8sClusterDetails environmentId={id} />
          ) : (
            <KaaSClusterDetailsWidget
              cloudProvider={environment.CloudProvider}
            />
          ))}
        <EnvironmentDetailsForm environment={environment} />
      </div>
    </>
  );
}
function isMicroK8s(environment: Environment) {
  return (
    environment.CloudProvider?.Name?.toLowerCase() ===
    k8sInstallTitles.microk8s.toLowerCase()
  );
}
